import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NewHomeView from '../views/NewHomeView.vue'
import Qr_V3 from '../views/Qr_V3_view.vue'

Vue.use(VueRouter)
const CustomerTemplate = {
  template: '<div>CustomerTemplate</div>',
}
const routes = [
  {
    path: '/:id',
    name: 'Qr_V3',
    component: Qr_V3
  },
  // {
  //   path: '/new/:id',
  //   name: 'NewHomeView',
  //   component: NewHomeView
  // },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   const publicPages = ['/'];
//   // , '/register'
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('event_id');
//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next('/signin');
//   } else {
//     next();
//   }
// });

export default router
